let storage = {
    hasDataStats: false,
    stats: {
        "client": "demo",
        "id_object": 0,
        "type_object": "",
        "date": "2018-01-01T12:12:12",
        "url": "demo.cc.com",
        "stats_url": "",
        "value_object" : 0,
        "email" : "",
        "user_id" : ""
    }
};

export default storage;



// WEBPACK FOOTER //
// ./src/storage.js